var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntersect1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 527,
    viewBox: "0 0 337 527",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.164 49.3773V527H0C5.12858 496.204 13.3188 465.234 23.2828 437.753C40.2286 391.363 62.4819 355.067 82.7119 322.072C102.028 290.567 119.499 262.07 128.745 230.668C137.539 202.134 139.532 171.15 141.435 141.562C143.775 105.185 145.979 70.9199 160.519 45.9155C187.56 0.57331 255.164 -14.3152 301.135 15.4618C314.061 23.8342 325.276 35.7913 336.164 49.3773Z",
    fill: "#FDBF50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersect1);
export default __webpack_public_path__ + "static/media/Intersect1.841f87246f852944585377d4f473bcf9.svg";
export { ForwardRef as ReactComponent };